var lib_core = require("lib-core");
var lib_geometry = require("lib-geometry");
var cio_datamodel = require("cio-datamodel");
var assetAdderStatemachineMixin = require("../../../shared/extensions/assetAdder/assetAdderStateMachineMixin");

var FootprintAddStateMachine = function (root, model, collection, switchermodel, userModel, url) {
    var self = this;

    this.root = root;
    this.model = model;
    this.collection = collection;
    this.url = url;
    self.switchermodel = switchermodel;
    self.userModel = userModel;
    this.assetType = 'footprint';

    lib_core.StateMachine.call(self);

    assetAdderStatemachineMixin(self);
};

lib_core.inherit(FootprintAddStateMachine, lib_core.StateMachine);

module.exports = FootprintAddStateMachine;


FootprintAddStateMachine.prototype.createInstance = function() {
    var self = this;

    // var alreadyHere = false;

    // self.collection.forEach(function(i, packageInstance){
    //     if(packageInstance.description().root.header["assetId"] == self.assetId){
    //         alreadyHere = true;
    //     }
    // });

    // if(!alreadyHere){

        var footprintDescription = self.root.dataLoader.getDescription(self.assetType, self.assetId, self.assetVersion);
        var footprintInstance = new cio_datamodel.FootprintInstanceData(footprintDescription);

        self.root.rec();
        self.collection.push(footprintInstance);
        self.root.stopRec();

        self.switchermodel.selectData(footprintInstance);
    // }
};
